import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import { ServiceOrderService } from '../../../core/services/service/service-order/service-order.service'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { MatDivider } from '@angular/material/divider'
import { MatProgressBar } from '@angular/material/progress-bar'
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component'
import { TableListTariffSelectComponent } from '../../../shared/components/table-list-tariff-select/table-list-tariff-select.component'
import { TableListSelectComponent } from '../../../shared/components/table-list-select/table-list-select.component'
import { PagedContactTypeResponse } from '../../../core/models/contact-type.model'
import { MatPaginator, PageEvent } from '@angular/material/paginator'
import { MatStepperModule } from '@angular/material/stepper'
import { MatSlideToggle } from '@angular/material/slide-toggle'
import { ErrorRequestModel } from '../../../core/models/response.model'

@Component({
  selector: 'service-order-replier',
  imports: [
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatIcon,
    MatFormField,
    MatInput,
    MatLabel,
    MatDivider,
    MatProgressBar,
    PaginationComponent,
    TableListTariffSelectComponent,
    TableListSelectComponent,
    MatPaginator,
    MatStepperModule,
    MatSlideToggle,
  ],
  templateUrl: './service-order-replier.component.html',
  styleUrl: './service-order-replier.component.scss',
  providers: [ServiceOrderService],
  standalone: true,
})
export class ServiceOrderReplier implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private serviceOrderService: ServiceOrderService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<ServiceOrderReplier>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.item = data.item
  }

  @Output() responseEdit = new EventEmitter()

  item: any = {}
  form: FormGroup = new FormGroup({})
  loadingBtn = false

  listOS: string[] = []
  listSelected: any[] = []
  selected: any = { id: -1, description: '' }

  page = 1
  rows = 10
  numberRows = 0

  itemsList: any[] = []
  loading = true

  columns: any[] = [
    {
      keyColumn: 'action',
      key: { select: true },
      description: '',
    },
    {
      keyColumn: 'codeOs',
      key: 'codigoOs',
      description: 'OS',
    },
    {
      keyColumn: 'os_service',
      key: 'os_service',
      description: 'Serviço',
    },
    {
      keyColumn: 'os_vehicle',
      key: 'os_vehicle',
      description: 'Veículo',
    },
    {
      keyColumn: 'pageDate',
      key: 'pageDate',
      description: 'Periodo',
    },
  ]

  ngOnInit(): void {
    this.getListOS()
    this.createForm()
  }

  close() {
    this.dialogRef.close()
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      hourStart: [{ value: '', disabled: true }],
      hourEnd: [{ value: '', disabled: true }],
      time: [false],
      observation: [false],
      passage: [false],
      itineraries: [false],
    })
  }

  createModel() {
    let hourStart = ''
    let hourEnd = ''
    const list: string[] = []
    if (this.form.get('time')?.value == true) {
      hourStart = this.form.get('hourStart')?.value + ':00'
      hourEnd = this.form.get('hourEnd')?.value + ':00'
    }
    for (let i = 0; i < this.listSelected.length; i++) {
      list.push(this.listSelected[i].id)
    }

    return {
      ordemServicoId: this.item.codigoOs,
      ordemServicoIds: list,
      horaInicial: hourStart,
      horaFinal: hourEnd,
      observacao: this.form.get('observation')?.value ? true : false,
      listaPassageiros: this.form.get('passage')?.value ? true : false,
      itinerarios: this.form.get('itineraries')?.value ? true : false,
    }
  }

  changeValue(event: any) {
    this.form.get('hourStart')?.setValue('')
    this.form.get('hourEnd')?.setValue('')
    if (event.checked) {
      this.form.get('hourStart')?.enable()
      this.form.get('hourEnd')?.enable()
      this.form.get('hourStart')?.setValidators(Validators.required)
      this.form.get('hourEnd')?.setValidators(Validators.required)
    } else {
      this.form.get('hourStart')?.disable()
      this.form.get('hourEnd')?.disable()
      this.form.get('hourStart')?.clearValidators()
      this.form.get('hourEnd')?.clearValidators()
    }
  }

  formatHour(hour: string | null) {
    if (hour) {
      const hourArr = hour.split(':')
      return `${hourArr[0]}:${hourArr[1]}`
    } else {
      return '-'
    }
  }

  getListOS() {
    this.loading = true
    this.serviceOrderService
      .getServiceOrderParents(this.item.codigoOs, this.page, this.rows)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1
    this.rows = event.pageSize
    this.uploadList()
  }

  uploadList() {
    this.getListOS()
  }

  treatResponse(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        list.push({ ...item })
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  selectItem(event: any) {
    const index = this.listSelected.findIndex((ele) => ele.id == event.codigoOs)
    if (index > -1) {
      this.listSelected.splice(index, 1)
    } else {
      this.listSelected.push({ ...event, id: event.codigoOs })
    }
  }

  validForm() {
    if (this.listSelected.length > 0) {
      if (
        (this.form.get('time')?.value == true &&
          this.form.get('hourStart')?.value != '' &&
          this.form.get('hourEnd')?.value != '') ||
        this.form.get('time')?.value == false
      ) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  importItem() {
    if (this.validForm()) {
      this.loadingBtn = true
      this.serviceOrderService
        .importDataServiceOrderParents(this.createModel())
        .subscribe({
          next: (response: any) => {
            this.responseEdit.emit(true)
            this.close()
          },
          error: (err: ErrorRequestModel) => {
            this.loadingBtn = false
            this.snackbar.errorRequest(err)
          },
          complete: () => {
            this.loadingBtn = false
          },
        })
    } else {
      this.snackbar.info('Dados inválidos.')
    }
  }
}
